export const EPLEDGE_HOLDING = "EPLEDGE_HOLDING";
export const EPLEDGE_HOLDING_OTP_ERROR = "EPLEDGE_HOLDING_OTP_ERROR";
export const EPLEDGE_HOLDING_OTP_HIDE_ERROR = "EPLEDGE_HOLDING_HIDE_ERROR";
export const EPLEDGE_HOLDING_OTP_START_LOADER = "EPLEDGE_HOLDING_START_LOADER";
export const EPLEDGE_HOLDING_OTP_STOP_LOADER = "EPLEDGE_HOLDING_STOP_LOADER";
